"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTableControl = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _utils = require("../../utils");

var _interfaces = require("../interfaces");

var useTableControl = function useTableControl(editorInstance, setModalToMount) {
  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isTableModalOpen = _useState2[0],
      setIsTableModalOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      isTableEditModalOpen = _useState4[0],
      setIsTableEditModalOpen = _useState4[1];

  var _useState5 = (0, _react.useState)(''),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      tableTitle = _useState6[0],
      setTableTitle = _useState6[1];

  var openTableModal = (0, _react.useCallback)(function () {
    setIsTableModalOpen(true);
    setModalToMount(_interfaces.RTEModals.Table);
  }, [setModalToMount]);
  var openTableEditModal = (0, _react.useCallback)(function (title) {
    setIsTableEditModalOpen(true);
    setTableTitle(title);
    setModalToMount(_interfaces.RTEModals.EditTable);
  }, [setModalToMount]);
  var closeTableModal = (0, _react.useCallback)(function () {
    setIsTableModalOpen(false);
  }, []);
  var closeTableEditModal = (0, _react.useCallback)(function () {
    setIsTableEditModalOpen(false);
  }, []);
  var onSetRowsAndColumns = (0, _react.useCallback)(function (rows, cols, ariaLabel) {
    if (editorInstance) {
      editorInstance.commands.table.insert(rows, cols, ariaLabel);
      setIsTableModalOpen(false);
    }
  }, [editorInstance]);
  var onSetTitle = (0, _react.useCallback)(function (title) {
    if (editorInstance) {
      editorInstance.commands.table.edit(title);
      setIsTableEditModalOpen(false);
    }
  }, [editorInstance]);
  var canOpenTableModal = (0, _react.useRef)(false);
  var canOpenTableEditModal = (0, _react.useRef)(false);
  var isEditorFocused = editorInstance && editorInstance.isFocused();
  canOpenTableModal.current = !!isEditorFocused && !isTableModalOpen;
  canOpenTableEditModal.current = !!isEditorFocused && !isTableEditModalOpen;
  (0, _react.useEffect)(function () {
    var handler = function handler(event) {
      var isCommandCtrlOption = event.ctrlKey && event.altKey;

      if (isCommandCtrlOption) {
        switch (event.code) {
          case _utils.EventKeyCodes.STR_DIGITS[5]:
            event.preventDefault();

            if (canOpenTableModal.current && editorInstance !== null && editorInstance !== void 0 && editorInstance.commands.table.canInsertTable()) {
              openTableModal();
            }

            break;

          case _utils.EventKeyCodes.STR_DIGITS[6]:
            event.preventDefault();

            if (editorInstance !== null && editorInstance !== void 0 && editorInstance.commands.table.canEditTable()) {
              var selectedTableAttributes = editorInstance.getAttributes('table');
              var ariaLabel = selectedTableAttributes["aria-label"];
              openTableEditModal(ariaLabel);
            }

            break;

          case _utils.EventKeyCodes.Q:
            event.preventDefault();

            if (editorInstance !== null && editorInstance !== void 0 && editorInstance.commands.table.canAddRowBelow()) {
              editorInstance.commands.table.addRowBelow();
            }

            break;

          case _utils.EventKeyCodes.W:
            event.preventDefault();

            if (editorInstance !== null && editorInstance !== void 0 && editorInstance.commands.table.canAddColumnAfter()) {
              editorInstance.commands.table.addColumnAfter();
            }

            break;

          case _utils.EventKeyCodes.E:
            event.preventDefault();

            if (editorInstance !== null && editorInstance !== void 0 && editorInstance.commands.table.canRemoveRow()) {
              editorInstance.commands.table.removeRow();
            }

            break;

          case _utils.EventKeyCodes.R:
            event.preventDefault();

            if (editorInstance !== null && editorInstance !== void 0 && editorInstance.commands.table.canRemoveColumn()) {
              editorInstance.commands.table.removeColumn();
            }

            break;

          case _utils.EventKeyCodes.T:
            event.preventDefault();

            if (editorInstance !== null && editorInstance !== void 0 && editorInstance.commands.table.canToggleHeaderRow()) {
              editorInstance.commands.table.toggleHeaderRow();
            }

            break;

          case _utils.EventKeyCodes.Y:
            event.preventDefault();

            if (editorInstance !== null && editorInstance !== void 0 && editorInstance.commands.table.canToggleHeaderColumn()) {
              editorInstance.commands.table.toggleHeaderColumn();
            }

            break;
        }
      }
    };

    document.addEventListener('keydown', handler);
    return function () {
      return document.removeEventListener('keydown', handler);
    };
  }, [editorInstance, openTableModal, openTableEditModal]);
  return {
    isTableModalOpen: isTableModalOpen,
    openTableModal: openTableModal,
    closeTableModal: closeTableModal,
    onSetRowsAndColumns: onSetRowsAndColumns,
    isTableEditModalOpen: isTableEditModalOpen,
    openTableEditModal: openTableEditModal,
    closeTableEditModal: closeTableEditModal,
    onSetTitle: onSetTitle,
    tableTitle: tableTitle
  };
};

exports.useTableControl = useTableControl;